module.exports = __webpack_public_path__ + "img/thumb_02.5855c173.jpg";